import React, { useEffect } from "react";

import queryString from "query-string";
import whatsapp from "../../../assets/common/whatsappG.svg";
import callMain from "../../../assets/common/callMain.svg";
import { setRecord } from "../../../store/reducers/paymentsReducer";
import { useDispatch, useSelector } from "react-redux";
import { FlexRowStart, RespFont } from "../Style";
import OpacityLoading from "../loader/OpacityLoading";
import { toast } from "react-toastify";

const SuccessPage = (props) => {
  const { paymentsLoading } = useSelector((state) => state.paymentsReducer);

  const dispatch = useDispatch();
  let params = queryString.parse(props.location.search);
  const { CCode, Fild1, Fild2, Amount, Id, ACode, Info, cell, Order, UserId } =
    params;
  useEffect(() => {
    if (parseInt(CCode) === 0)
      dispatch(
        setRecord({
          Fild1,
          Fild2,
          Amount,
          Id,
          ACode,
          Info,
          cell,
          Order,
          UserId,
        })
      ).then((res) => {
        if (res.payload?.error) {
          window.open(`${res.payload.error}`, "_blank");
          toast.warning("התשלום בוצע אך לא נרשם, יש לפנות למוקד");
        } else toast.success("התשלום בוצע בהצלחה!!!");
      });
  }, []);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("bela");
    }, 5000);
  }, []);

  const handleClickScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <RespFont
        pSize={"32px"}
        cSize={"38px"}
        style={{
          fontFamily: "Merriweather",
          letterSpacing: "3px",
          marginTop: "30px",
        }}
      >
        CallUp
      </RespFont>
      <RespFont
        pSize={"18px"}
        cSize={"24px"}
        style={{ fontFamily: "MonsterB" }}
      >
        מערכת אישורי הגעה וסידורי הושבה לאירועים
      </RespFont>

      <RespFont>
        <RespFont
          pSize={"16px"}
          cSize={"20px"}
          style={{ fontFamily: "hebM", marginTop: "20px" }}
        >{`התשלום עבור ${Info} בוצע בהצלחה!`}</RespFont>
        <div style={{ width: "90%", margin: "10px auto", textAlign: "right" }}>
          <FlexRowStart style={{ alignItems: "baseline" }}>
            <p style={{ fontFamily: "hebM", marginLeft: "5px" }}>שם לקוח:</p>
            {Fild1}
          </FlexRowStart>
          <FlexRowStart style={{ alignItems: "baseline" }}>
            <p style={{ fontFamily: "hebM", marginLeft: "5px" }}>סכום:</p>
            {Amount}₪
          </FlexRowStart>
          <FlexRowStart style={{ alignItems: "baseline" }}>
            <p style={{ fontFamily: "hebM", marginLeft: "5px" }}>מספר עסקה:</p>
            {Id}
          </FlexRowStart>
          <FlexRowStart style={{ alignItems: "baseline" }}>
            <p style={{ fontFamily: "hebM", marginLeft: "5px" }}>מספר אישור:</p>
            {ACode}
          </FlexRowStart>
        </div>
      </RespFont>

      <RespFont style={{ marginTop: "50px" }}>
        נתקלתם בבעיה? פנו לתמיכה
      </RespFont>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "center",
          width: "100%",
          maxWidth: "600px",
          margin: "10px auto",
          marginTop: "10px",
        }}
      >
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://wa.me/972547439322/?text=`}
          style={{
            cursor: "pointer",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "min-content",
            padding: "10px 20px",
            borderRadius: "3px",
            boxShadow: "0 2px 4px silver",
            backgroundColor: "rgba(255,255,255,0.7)",
            textDecoration: "none",
            color: "#3a3c3f",
          }}
        >
          <RespFont>ווצאפ</RespFont>
          <img
            src={whatsapp}
            alt={"whatsapp"}
            style={{ width: "30px", marginRight: "20px" }}
          />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href={`tel:0547439322`}
          style={{
            cursor: "pointer",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "min-content",
            padding: "10px 20px",
            borderRadius: "3px",
            boxShadow: "0 2px 4px silver",
            backgroundColor: "rgba(255,255,255,0.7)",
            textDecoration: "none",
            color: "#3a3c3f",
          }}
        >
          <RespFont>שיחה</RespFont>
          <img
            src={callMain}
            alt={"callMain"}
            style={{ width: "30px", marginRight: "20px" }}
          />
        </a>
      </div>
      {paymentsLoading && <OpacityLoading />}
    </div>
  );
};

export default SuccessPage;
